import React from 'react';
import { DownOutline } from 'antd-mobile-icons';
import './styles/index.less.js';
import classNames from 'classnames';
import { isFunction } from 'lodash';
import useCollapse from '../hooks/useCollapse/index.js';

var collapseIconProps = {
  fontSize: 18,
  color: '#9EA1A7'
};
var TiCard = function TiCard(props) {
  var _a, _b, _c;
  var title = props.title,
    collapse = props.collapse,
    extra = props.extra,
    _d = props.primary,
    primary = _d === void 0 ? true : _d,
    children = props.children,
    style = props.style,
    shadow = props.shadow,
    bodyStyle = props.bodyStyle,
    onContentClick = props.onContentClick;
  var _e = useCollapse({
      defaultExpanded: true
    }),
    getCollapseProps = _e.getCollapseProps,
    isExpanded = _e.isExpanded,
    setExpanded = _e.setExpanded;
  var handleContentClick = function handleContentClick(event) {
    if (isFunction(onContentClick)) {
      onContentClick(event);
    }
  };
  var handleHeaderClick = function handleHeaderClick() {
    if (collapse) {
      setExpanded(function (pre) {
        return !pre;
      });
    }
  };
  var cardCls = classNames((_a = {}, _a['ti-card'] = true, _a['ti-card-shadow'] = shadow, _a));
  var arrowCls = classNames((_b = {}, _b['ti-card-header-arrow'] = true, _b['ti-card-header-arrow-active'] = !isExpanded, _b));
  var bodyCls = classNames((_c = {}, _c['ti-card-title-body'] = title, _c['ti-card-body'] = !title, _c));
  var arrowIcon = /*#__PURE__*/React.createElement("div", {
    className: arrowCls
  }, /*#__PURE__*/React.createElement(DownOutline, collapseIconProps));
  return /*#__PURE__*/React.createElement("div", {
    className: cardCls,
    style: style
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header",
    onClick: handleHeaderClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header-left"
  }, primary ? /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header-primary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header-primary-icon"
  }), ' ') : null, /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header-title"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header-right"
  }, extra ? /*#__PURE__*/React.createElement("div", {
    className: "ti-card-header-extra"
  }, extra) : null, collapse ? arrowIcon : null)) : null, /*#__PURE__*/React.createElement("div", getCollapseProps(), /*#__PURE__*/React.createElement("div", {
    className: bodyCls,
    style: bodyStyle,
    onClick: handleContentClick
  }, children)));
};

export { TiCard as default };
